import { useLingui } from '@lingui/react/macro';

import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { getCountryName } from '@/utils/country';

import { Item } from './Item';

export const ArticlePurchaseCountry = () => {
  const { t } = useLingui();
  const { article } = useArticleContext();

  return (
    <Item
      label={t({ id: 'article.information.purchase-country', message: 'Purchase country' })}
      value={article.purchaseCountry ? getCountryName(article.purchaseCountry) : null}
    />
  );
};
